import { BaseAction } from "../../../core/actions/BaseAction";
import { isEmpty } from "../../../Lib/Utils/validationUtil";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApplyPromoCodeActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/PromoCodeActionParams";
import { getAppliedPromoCodes, updateBookingPromoCodes } from "./promoCodeHelper";

export class ApplyPromoCodeAction extends BaseAction<string, IApplyPromoCodeActionParams> {
    override async run(): Promise<string> {
        let actionResponse = "";
        try {
            const { bookingId, promoCode } = this.params!;
            const code = (promoCode || "").trim();
            if (!bookingId) {
                return actionResponse;
            }
            if (isEmpty(code)) {
                updateRecoilState("promoCodeErrorAtom", "promoCodeRequired");
                return actionResponse;
            }
            const alreadyApplied = getRecoilStateValue<string[]>("listOfAppliedPromoCodeAtom", []) || [];
            if (alreadyApplied.some(c => c.toLowerCase() === code.toLowerCase())) {
                updateRecoilState("promoCodeErrorAtom", "promoCodeAlreadyApplied");
                return actionResponse;
            }

            const booking = await updateBookingPromoCodes(bookingId, [...alreadyApplied, code]);
            if (!booking) {
                updateRecoilState("promoCodeErrorAtom", "invalidPromoCode");
                return actionResponse;
            }
            // The booking is the source of truth: a code the shop accepted but
            // did not apply to any offer part is not a discount for the customer.
            const applied = getAppliedPromoCodes(booking);
            if (!applied.some(c => c.toLowerCase() === code.toLowerCase())) {
                updateRecoilState("promoCodeErrorAtom", "invalidPromoCode");
                return actionResponse;
            }
            updateRecoilState("promoCodeErrorAtom", "");
            actionResponse = "success";
        } catch (error) {
            console.error("Error applying promo code", error);
            updateRecoilState("promoCodeErrorAtom", "apiErrorMsg");
        } finally {
            return actionResponse;
        }
    }
}

export const applyPromoCodeAction = new ApplyPromoCodeAction();
